import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { theme } from '@/theme';

export const StepperWrapper = styled(Flex)`
  overflow: auto;
`;

const getLineColor = (
  isActive: boolean,
  isCompleted: boolean,
  isVertical: boolean,
) => {
  if (isVertical) {
    return isActive || isCompleted
      ? theme.colors.primary
      : theme.colors.mediumGrey;
  }
  return isCompleted ? theme.colors.primary : theme.colors.mediumGrey;
};

export const StepContainer = styled(Flex)<{
  isActive: boolean;
  isCompleted: boolean;
  isFullWidth: boolean;
  vertical: boolean;
}>`
  position: relative;
  align-items: center;
  margin-bottom: 10px;

  ${({ isActive, isCompleted, isFullWidth, theme, vertical }) => css`
    ${!vertical &&
    css`
      padding: ${theme.spacing(0, 1)};
    `}
    flex-direction: ${vertical ? 'row' : 'column'};
    width: ${vertical ? 'auto' : isFullWidth ? '100%' : '140px'};

    &::after {
      content: '';
      position: absolute;
      top: ${vertical ? '24px' : '12px'};
      right: ${vertical ? '100%' : '-50%'};
      height: ${vertical ? '100%' : '2px'};
      left: ${vertical ? '12px' : 'auto'};
      background-color: ${getLineColor(isActive, isCompleted, vertical)};
    }

    &:not(:last-child)::after {
      width: ${vertical ? '2px' : '100%'};
    }
  `}
`;

export const StepBadge = styled(Flex)<{
  isActive: boolean;
  isCompleted: boolean;
}>`
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
  z-index: 2;

  ${({
    isActive,
    isCompleted,
    theme: {
      colors,
      components: { stateStepper },
    },
  }) => css`
    width: ${stateStepper.badge.width};
    height: ${stateStepper.badge.height};
    border: ${stateStepper.badge.borderWidth} solid
      ${isActive || isCompleted ? colors.primary : colors.mediumGrey};
    border-radius: ${stateStepper.badge.borderRadius};
    background-color: ${isCompleted ? colors.primary : colors.white};
  `}
`;

export const TextContainer = styled(Box)<{ vertical: boolean }>`
  ${({ vertical }) => css`
    text-align: ${vertical ? 'left' : 'center'};
  `}
`;

export const CheckMark = styled(Box)`
  width: 13px;
  height: 7px;
  border: solid black;
  border-width: 0 0 2px 2px;
  transform: rotate(-45deg);
`;
